<template>
    <div class="col-lg-12">
    <cookie-law class="cookie-container">
        <div slot-scope="props" style="">
            <div class="row">
                <div class="col-lg-6 col-sm-12 text-center">
                    <p class="cookie-text">
                        Si continúas navegando en nuestra página web, consideramos que aceptas el uso
                        de cookies. Para más información da click <b-link class="politicas-link" href="" to="/aviso">aquí</b-link>
                    </p>
                </div>

                <div class="col-lg-6 col-sm-12 btns">
                    <button class="btn_cookie" @click="props.accept">Aceptar</button>
                    <button class="btn_cookie" @click="props.close">Denegar</button>
                </div>
            </div>
        </div>
    </cookie-law>
    </div>
</template>

<script>
  import CookieLaw from 'vue-cookie-law'
  export default {
    props:{
        buttonText: 'aceptar',
        message: 'Hola cookies'
    },
    components: { CookieLaw }
  }
</script>

<style scoped>
    .cookie-container {
        background: #4265ac;
        color: #fff;
        padding: 1.25em;
        display: block;
        height: 10%;
    }

    .cookie-text {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 16px;
        line-height: 23px;

        letter-spacing: 0.2px;
        color: #FFFFFF;
        padding-left: 150px;
    }

    .politicas-link {
        color: #a2e6e0;
    }

    .btn_cookie {
        font-family: Muli-Bold;
        font-style: normal;
        font-size: 14px;
        line-height: 18px;
        text-align: center;
        letter-spacing: 0.3px;

        color: #FFFFFF;
        border-radius: 25px;
        border-color: #a2e6e0;
        border-style: solid;
        padding: 0.625em 3.125em;
        margin: 0px 15px;
        background: #4265ac;

        outline: 0;
    }

    .Cookie--mytheme .Cookie__button:hover {
        background: #0B19B5 !important;
    }

     @media(max-width: 768px){
    .cookie-container {
        padding: 0px;
        height: 30%;
    }

    .cookie-text {
        font-family: Muli-Semibold;
        font-style: normal;
        font-size: 16px;
        line-height: 23px;
        letter-spacing: 0.2px;
        color: #FFFFFF;
        padding-left: 0px;
    }

    .politicas-link {
        color: #a2e6e0;
    }

    .btns{
        display: -ms-flexbox !important;
        display: flex !important;
    }
        }

</style>